import {findInGroupFilters} from '../utils/filterPillUtils';
import {getGroupFiltersSelected} from '../utils/filters';

import {Props as FilterGroupPillProps} from '../components/FilterGroupPill/FilterGroupPill';
import {
    PRICE_FILTER_GROUP_ID,
    ROOMSANDSPACES_FILTER_GROUP_ID,
} from '../constants/filters';
import {FilterGroupType} from '../components/MoreFilters/MoreFilters';

type GetSelectionByGroup = Pick<
    FilterGroupPillProps,
    'filters' | 'selectedFilters' | 'customFiltersParams'
>;

type SelectionByGroup = {
    isPriceSelected: boolean;
    isRoomsAndSpacesSelected: boolean;
    isOthersSelected: boolean;
};

// eslint-disable-next-line complexity
export function getSelectionByGroup({
    filters,
    selectedFilters,
    customFiltersParams,
}: GetSelectionByGroup): SelectionByGroup {
    const {
        selectedMaxPrice,
        selectedMinPrice,
        selectedMinBedrooms,
        selectedMinBathrooms,
    } = customFiltersParams;
    const isOthersSelected =
        getGroupFiltersSelected(filters, selectedFilters).length > 0;
    const isPriceSelected = !!selectedMaxPrice || !!selectedMinPrice;
    const isRoomsAndSpacesSelected =
        !!selectedMinBedrooms || !!selectedMinBathrooms || isOthersSelected;

    return {
        isPriceSelected,
        isRoomsAndSpacesSelected,
        isOthersSelected,
    };
}

type ShouldShowClearButton = Pick<FilterGroupPillProps, 'groupId'> & {
    selectionByGroup: SelectionByGroup;
    filterGroups?: FilterGroupType[];
};

// eslint-disable-next-line complexity
export function shouldShowClearButton({
    filterGroups,
    groupId,
    selectionByGroup,
}: ShouldShowClearButton): boolean {
    const {
        isPriceSelected,
        isRoomsAndSpacesSelected,
        isOthersSelected,
    } = selectionByGroup;

    if (groupId) {
        if (groupId === PRICE_FILTER_GROUP_ID) {
            return isPriceSelected;
        } else if (groupId === ROOMSANDSPACES_FILTER_GROUP_ID) {
            return isRoomsAndSpacesSelected;
        }
        return isOthersSelected;
    } else if (filterGroups) {
        return [
            isOthersSelected,
            findInGroupFilters(filterGroups, PRICE_FILTER_GROUP_ID)
                ? isPriceSelected
                : false,
            findInGroupFilters(filterGroups, ROOMSANDSPACES_FILTER_GROUP_ID)
                ? isRoomsAndSpacesSelected
                : false,
        ].some((item) => item);
    }

    return isPriceSelected || isRoomsAndSpacesSelected || isOthersSelected;
}
